import ApplicationRecord from '@/models/application_record'

import {
  Model,
  Attr
} from 'spraypaint'

@Model()
export default class Company extends ApplicationRecord {
  static jsonapiType = 'companies'

  @Attr name!: string
}
